import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToasterWidgetModule } from '../toaster-widget/toaster-widget.module';
import { CalculateWidgetComponent } from './calculate-widget.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PipesModule } from '@libs/modules/pipes.module';
import { PlatformIfDirective } from '@libs/directives/platform-id.directive';

@NgModule({
  declarations: [CalculateWidgetComponent],
  exports: [CalculateWidgetComponent],
  imports: [
    CommonModule,
    PipesModule,
    NgxSliderModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    ToasterWidgetModule,
    PlatformIfDirective,
  ],
})
export class CalculateWidgetModule {}
